import { DocumentPage } from "../../components/layout/DocumentPage";
import { PageHeader } from "../../components/layout/PageHeader";
import { profile } from "../../data/profile";
import styles from "./Contact.module.css";

export function Contact() {
  return (
    <DocumentPage id="contact" pageNumber={6} tone="ink" className={styles.contactPage}>
      <PageHeader
        eyebrow="06 / CONTACT"
        title={"복잡한 요구사항을 구조화하고, 실제 현장에서 작동하는 서비스로 구현합니다."}
        description="프론트엔드부터 API, 데이터베이스, 모바일과 외부 장비 연동까지 서비스 전 영역을 일관된 구조로 설계하고 구현합니다."
        wideDescription
      />
      <div className={styles.contactList}>
        <a href={`mailto:${profile.email}`}><span>이메일</span><strong>{profile.email}</strong></a>
        <a href={`tel:${profile.phone.replaceAll("-", "")}`}><span>전화</span><strong>{profile.phone}</strong></a>
        <a href={profile.blog} target="_blank" rel="noreferrer"><span>블로그</span><strong>sime.tistory.com</strong></a>
        <div><span>거주지</span><strong>{profile.location}</strong></div>
      </div>
    </DocumentPage>
  );
}
